export enum FavoriteEntityTypeEnum {
  PropertyAd = 'PROPERTY_AD',
}

export enum ListCategoryEnum {
  EstatePropertySales = 'ESTATE_PROPERTY_SALES',
  EstateCommercialSales = 'ESTATE_COMMERCIAL_SALES',
  EstateLandSales = 'ESTATE_LAND_SALES',
  EstatePropertyRent = 'ESTATE_PROPERTY_RENT',
  EstateCommercialRent = 'ESTATE_COMMERCIAL_RENT',
  EstateLandRent = 'ESTATE_LAND_RENT',
  EstatePropertySalesUnknown = 'ESTATE_PROPERTY_SALES_UNKNOWN',
  EstatePropertyRentUnknown = 'ESTATE_PROPERTY_RENT_UNKNOWN',
  EstatePropertyUnknown = 'ESTATE_PROPERTY_UNKNOWN',
}

export enum I18nSupportedFormat {
  LocalNumber = 'LOCAL_NUMBER',
  LocalCurrency = 'LOCAL_CURRENCY',
}

export enum SupportedLocaleEnum {
  El = 'el',
}

export enum PropertyAttributeEnum {
  ESTATE_PROPERTY_TYPE = 'ESTATE_PROPERTY_TYPE',
  ESTATE_PROPERTY_COMMERCIAL_TYPE = 'ESTATE_PROPERTY_COMMERCIAL_TYPE',
  ESTATE_PROPERTY_LAND_TYPE = 'ESTATE_PROPERTY_LAND_TYPE',
  ESTATE_PROPERTY_BEDROOMS = 'ESTATE_PROPERTY_BEDROOMS',
  ESTATE_PROPERTY_FLOOR = 'ESTATE_PROPERTY_FLOOR',
  ESTATE_PROPERTY_ENERGY_CLASS = 'ESTATE_PROPERTY_ENERGY_CLASS',
  ESTATE_PROPERTY_BATHROOMS = 'ESTATE_PROPERTY_BATHROOMS',
  ESTATE_PROPERTY_WC = 'ESTATE_PROPERTY_WC',
  ESTATE_PROPERTY_RENOVATION_YEAR = 'ESTATE_PROPERTY_RENOVATION_YEAR',
  ESTATE_PROPERTY_HEAT = 'ESTATE_PROPERTY_HEAT',
  ESTATE_PROPERTY_HEAT_TYPE = 'ESTATE_PROPERTY_HEAT_TYPE',
  ESTATE_PROPERTY_EXTRAS = 'ESTATE_PROPERTY_EXTRAS',
  ESTATE_PROPERTY_COMMERCIAL_EXTRAS = 'ESTATE_PROPERTY_COMMERCIAL_EXTRAS',
  ESTATE_PROPERTY_LAND_EXTRAS = 'ESTATE_PROPERTY_LAND_EXTRAS',
  ESTATE_PROPERTY_SPACES = 'ESTATE_PROPERTY_SPACES',
  ESTATE_PROPERTY_OFFICES = 'ESTATE_PROPERTY_OFFICES',
  ESTATE_LAND_PROPERTY_CITY_PLAN = 'ESTATE_LAND_PROPERTY_CITY_PLAN',
  ESTATE_PROPERTY_USAGE = 'ESTATE_PROPERTY_USAGE',
  ESTATE_LAND_PROPERTY_PLOT_WIDTH = 'ESTATE_LAND_PROPERTY_PLOT_WIDTH',
  ESTATE_LAND_PROPERTY_PLOT_LENGTH = 'ESTATE_LAND_PROPERTY_PLOT_LENGTH',
  ESTATE_PROPERTY_ACCESS = 'ESTATE_PROPERTY_ACCESS',
}

export enum EstatePropertyTypeEnum {
  Appartment = 'appartment',
  SingleResidence = 'single_residence',
  Maisonette = 'maisonette',
  Building = 'building',
  Rest = 'rest_types',
}

export enum LandPropertyTypeEnum {
  PlotOfLand = 'plot_of_land',
  Island = 'island',
  Plot = 'plot',
  Other = 'other_land_types',
}

export enum CommercialEstatePropertyTypeEnum {
  Office = 'office',
  Store = 'store',
  IndustrialArea = 'industrial_area',
  CraftSpace = 'craft_space',
  Warehouse = 'warehouse',
  Hotel = 'hotel',
  CommercialBuilding = 'commercial_building',
  Hall = 'hall',
  Parking = 'parking',
  Rest = 'rest_commercial_types',
}

export enum EstatePropertyEnergyClassEnum {
  aPlus = 'a+',
  a = 'a',
  bPlus = 'b+',
  b = 'b',
  c = 'c',
  d = 'd',
  e = 'e',
  z = 'z',
  h = 'h',
  not_provided = 'not_provided',
}

export enum EstatePropertyExtrasEnum {
  FireplaceNo = 'fireplace_no',
  Fireplace = 'fireplace',
  ElevatorNo = 'elevator_no',
  Elevator = 'elevator',
  EstateParkingNo = 'parking_no',
  EstateParking = 'parking',
  FurnishedNo = 'furnished_no',
  Furnished = 'furnished',
}
export enum EstatePropertyCommercialExtrasEnum {
  FireplaceNo = 'fireplace_no',
  Fireplace = 'fireplace',
  ElevatorNo = 'elevator_no',
  Elevator = 'elevator',
  EstateParkingNo = 'parking_no',
  EstateParking = 'parking',
}
export enum EstatePropertyLandExtrasEnum {
  CompensationNo = 'compensation_no',
  Compensation = 'compensation',
  WithBuilding = 'with_building',
  WithBuildingNo = 'with_building_no',
}

export enum EstatePropertyHeatEnum {
  HeatWithout = 'heat_without',
  HeatCentral = 'heat_central',
  HeatIndividual = 'heat_individual',
  HeatAutonomous = 'heat_autonomous',
}

export enum EstatePropertyFloorEnum {
  '2nd_basement' = '2nd_basement',
  basement = 'basement',
  semi_basment = 'semi_basment',
  ground_floor = 'ground_floor',
  ground_floor_raised = 'ground_floor_raised',
  mezzanine = 'mezzanine',
  mezzanine_raised = 'mezzanine_raised',
  '1st' = '1st',
  '1st_raised' = '1st_raised',
  '2nd' = '2nd',
  '3rd' = '3rd',
  '4th' = '4th',
  '5th' = '5th',
  '6th' = '6th',
  '7th' = '7th',
  '8th' = '8th',
  '9th' = '9th',
  '10th' = '10th',
  '11th' = '11th',
  '12th' = '12th',
  '13th' = '13th',
  '14th' = '14th',
  '15th' = '15th',
  '16th' = '16th',
  '17th' = '17th',
  '18th' = '18th',
  '19th' = '19th',
  '20th' = '20th',
  '20+' = '20+',
}

export enum EstateLandPropertyCityPlansEnum {
  OutOfCityPlans = 'out_of_city_plans',
  InCityPlans = 'in_city_plans',
  WithinStettlement = 'within_settlement',
  InBuildingZone = 'in_building_zone',
  SettlementLimits = 'settlement_limits',
  TangentialPlan = 'tangential_plan',
  ToBeIncluded = 'to_be_included',
}

export enum EstatePropertyUsageEnum {
  PureHouse = 'pure_house',
  IndustrialZone = 'industrial_zone',
  CraftZone = 'craft_zone',
  GrazingLand = 'grazing_land',
  GeneralHouse = 'general_house',
  ForestArea = 'forest_area',
  RedZone = 'red_zone',
  ArableLand = 'arable_land',
  TouristInvestment = 'tourist_investment',
  IndustrialParkLightServing = 'industrial_park_light_industrial_serving',
  IndustrialParkFullServing = 'industrial_park_full_industrial_serving',
  IndustrialParkLowMediumServing = 'industrial_park_low_and_medium_industrial_serving',
  UncharacteristicZone = 'uncharacteristic_zone',
  WholesaleZone = 'wholesale_zone',
  AgriculturalArea = 'agricultural_area',
  CommercialZone = 'commercial_zone',
  Unspecified = 'unspecified',
  FarmersBuildings = 'farmers_buildings',
  AgriculturalWarehouses = 'agricultural_warehouses',
  Tanks = 'tanks',
  GreenHouses = 'greenhouses',
  IndustrialBuildings = 'industrial_buildings',
  Warehouses = 'warehouses',
  SportFacilities = 'sports_facilities',
  Schools = 'schools',
  CharitableFoundations = 'charitable_foundations',
  Hospitals = 'hospitals',
  Clinics = 'clinics',
  Offices = 'offices',
  Stores = 'stores',
  TouristFacilities = 'tourist_facilities',
  Churches = 'churches',
  WithinOfTheUrbanPlan = 'within_the_urban_plan',
  OutOfTheUrbanPlan = 'out_of_the_urban_plan',
  MildHarassment = 'mild_harassment',
  UrbanCenter = 'urban_center',
  PublicBenefitOrganization = 'public_benefit_organizations',
  AudienceGatheringSpace = 'audience_gathering_space',
  ReligiousSpace = 'religious_space',
}

export enum SortingCategoryEnum {
  DateCreated = 'DATE_CREATED',
  SalesPrice = 'SALES_PRICE',
  SalesPricePerSqrMeter = 'SALES_PRICE_PER_SQR_METER',
}

export enum SortingOrderEnum {
  Ascending = 'ASC',
  Descending = 'DESC',
}

export enum AgentStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invalid = 'INVALID',
  Deleted = 'DELETED',
}

export enum PropertyAdStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invalid = 'INVALID',
  Deleted = 'DELETED',
}

export enum SourceEnum {
  EstatePlus = 'ESTATE_PLUS',
  Fortunet = 'FORTUNET',
  None = 'NONE',
  Orbit = 'ORBIT',
  RealStatus = 'REAL_STATUS',
  IList = 'ILIST',
  GoldenHome = 'GOLDEN_HOME',
  Zoia = 'ZOIA',
}

export enum PropertyAdTypeEnum {
  PROPERTY = 'PROPERTY',
  COMMERCIAL = 'COMMERCIAL',
  LAND = 'LAND',
  UNKNOWN = 'UNKNOWN',
}

export enum PropertyAdCategoryEnum {
  EstatePropertySales = 1,
  EstatePropertyRent = 4,
  EstateCommercialSales = 2,
  EstateCommercialRent = 5,
  EstateLandSales = 3,
  EstateLandRent = 6,
}

export enum PropertyAdSubCategoryEnum {
  Appartment = 'APPARTMENT',
  SingleResidence = 'SINGLE_RESIDENCE',
  Maisonette = 'MAISONETTE',
  Building = 'BUILDING',
  RestTypes = 'REST_TYPES',
  Office = 'OFFICE',
  Store = 'STORE',
  IndustrialArea = 'INDUSTRIAL_AREA',
  CraftSpace = 'CRAFT_SPACE',
  Warehouse = 'WAREHOUSE',
  Hotel = 'HOTEL',
  CommercialBuilding = 'COMMERCIAL_BUILDING',
  Hall = 'HALL',
  Parking = 'PARKING',
  RestCommercialTypes = 'REST_COMMERCIAL_TYPES',
  PlotOfLand = 'PLOT_OF_LAND',
  Island = 'ISLAND',
  Plot = 'PLOT',
  OtherLandTypes = 'OTHER_LAND_TYPES',
  Unknown = 'UNKNOWN',
}

export enum PropertyAdCategoryTypeEnum {
  Sell = 'SELL',
  Rent = 'RENT',
  Unknown = 'UNKNOWN',
}
export enum PublishingStatusEnum {
  Failed = 'PUBLISHING_FAILED',
  Success = 'SEND_FOR_PUBLISHING',
  Pending = 'PENDING_FOR_ATTACHMENTS_HANDLING',
  InProgress = 'IN_PROGRESS_ATTACHMENTS_HANDLING',
}

export enum GA_Events {
  PageView = 'PAGE_VIEW',
  AddToFavorites = 'ADD_FAVORITE',
  RemoveFromFavorites = 'REMOVE_FAVORITE',
}
